import callApi from "./callApi";

const signOutUser = () => {
  callApi((api) => api.signOutUser());
};

export default signOutUser;
